function historicoProvisionamento(orcamento_id) {
    startLoading();
    $('.tr-provisionamentos').remove();

    $.ajax({
        url: '/provisionamento/item/historico-provisionamento',
        data: {
            orcamento_id: orcamento_id
        }
    }).done(function (retorno) {
        $('#modal-provisionamento-titulo').text(retorno.titulo);
        $('#tbody-provisionamento').append(retorno.trs);
        $('#modal-historico-provisionamento').modal('show');
        // adiciona o scroll após fechar o modal
        $('#modal-historico-provisionamento').on('hidden.bs.modal', function(e){
          $("body").addClass("modal-open");
        });

        stopLoading();
    });
}

function visualizarAnaliseTotal(value) {
    if (value == 'orcamento') {
        $('#visualizar-analise-orcamento').css('display', '');
        $('#visualizar-analise-gerencial').css('display', 'none');
        $('#hr-gerencial').css('display', 'none');
    } else if (value == 'gerencial') {
        $('#visualizar-analise-orcamento').css('display', 'none');
        $('#visualizar-analise-gerencial').css('display', '');
        $('#hr-gerencial').css('display', 'none');
    } else {
        $('#visualizar-analise-orcamento').css('display', '');
        $('#visualizar-analise-gerencial').css('display', '');
        $('#hr-gerencial').css('display', '');
    }
}

function visualizarAnalisePorServico(value, servico_id) {
    if (value == 'orcamento') {
        $('#visualizar-analise-orcamento-' + servico_id).css('display', '');
        $('#visualizar-analise-gerencial-' + servico_id).css('display', 'none');
        $('#hr-gerencial-' + servico_id).css('display', 'none');
    } else if (value == 'gerencial') {
        $('#visualizar-analise-orcamento-' + servico_id).css('display', 'none');
        $('#visualizar-analise-gerencial-' + servico_id).css('display', '');
        $('#hr-gerencial-' + servico_id).css('display', 'none');
    } else {
        $('#visualizar-analise-orcamento-' + servico_id).css('display', '');
        $('#visualizar-analise-gerencial-' + servico_id).css('display', '');
        $('#hr-gerencial-' + servico_id).css('display', '');
    }
}

function showHideAnalisePorServico(servico_id) {
    tr_servico = $('#tr-analise-servico-' + servico_id);

    if (tr_servico.is(':visible')) {
        tr_servico.css('display', 'none');
    } else {
        tr_servico.css('display', '');
    }
}
